<template>
    <div class="page-403">

        <div class="content">
            <div class="icon"></div>

            <div class="text">
                <div class="title">Запрос отклонён</div>
                <div class="desc">
                    У вас нет разрешения на доступ к этой странице
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'Page403',

};
</script>

<style lang="scss" scoped>
@import "@dsee/mixins";

.page-403 {
    height: calc(100vh - (var(--footer-height) + var(--header-height)));
    display: flex;

    .content {
        margin: auto;
    }

    .icon {
        background-image: url('icons/403.png');
        background-size: contain;
        @include icon(418px, 177px);
        cursor: default;
    }

    .text {
        margin-top: 20px;
        text-align: center;

        .title {
            font-size: 16px;
            font-weight: 700;
            line-height: 22px;
        }

    }

}
</style>
